import { event } from './index';

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchEventList(option) {
  return event.post('list.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchEventDetail(option) {
  return event.post('detail.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchJoinEventList(option) {
  return event.post('joinList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchEventWinnerList(option) {
  return event.post('winnerList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function joinEvent(option) {
  return event.post('join.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function insertAddress(option) {
  return event.post('addrInsert.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { fetchEventList, fetchEventDetail, fetchJoinEventList, fetchEventWinnerList, joinEvent, insertAddress }